import ApiClient from "@/api/ApiClient";
import {
  ShippingAddressListResponse,
  ShippingAddressResponse,
} from "@API/src/component/memoruHome/shippingAddress/types";
import {
  DeleteShippingAddressRequest,
  FetchShippingAddressListRequest,
  PostShippingAddressRequest,
  PutShippingAddressRequest,
} from "@/model/request/shippingAddress";
import {
  isTypeShippingAddressListResponse,
  isTypeShippingAddressResponse,
} from "@/model/typeGuard/shippingAddress";
import { isTypeSuccessResponse } from "@/model/typeGuard/success";
import { SuccessResponse } from "../../node_modules/chaild-entity/src/common/response/response";

export default class ApiShippingAddress {
  public static async fetchShippingAddressList(
    request: FetchShippingAddressListRequest
  ): Promise<ShippingAddressListResponse> {
    const response = await ApiClient.get(`/shipping-address`, request);
    if (isTypeShippingAddressListResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async postShippingAddress(
    request: PostShippingAddressRequest
  ): Promise<ShippingAddressResponse> {
    const response = await ApiClient.post(`/shipping-address`, request);
    if (isTypeShippingAddressResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async putShippingAddress(
    request: PutShippingAddressRequest
  ): Promise<ShippingAddressResponse> {
    const response = await ApiClient.put(
      `/shipping-address/${request.shippingAddressId}`,
      request
    );
    if (isTypeShippingAddressResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async deleteShippingAddress(
    request: DeleteShippingAddressRequest
  ): Promise<SuccessResponse> {
    const response = await ApiClient.delete(
      `/shipping-address/${request.shippingAddressId}`,
      request
    );
    if (isTypeSuccessResponse(response)) {
      return response;
    }
    throw response;
  }
}
